import { HttpAdapter } from "../../main/adapters/HttpAdapter";

/**
 * @class
 * Responsavel por cuidar dos dados do Departamento Fiscal e Pessoal
 */
export class Department {
    HttpAdapter = new HttpAdapter();
    baseUrlDataTimeseries = `${publicSettings.aws.baseUrls.dataTimeseries}`;
    constructor(Dashboard, Serie, Available, Point, Company) {
        this.Dashboard = Dashboard;
        this.Serie = Serie;
        this.Available = Available;
        this.Point = Point;
        this.Company = Company;
    }

    async copyDepartmentStructureTo({
        companyIdFrom,
        companyIdTo,
        accounting,
        sources
    }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlDataTimeseries}/serie/copy-structure`,
            {
                companyIdFrom,
                companyIdTo,
                accounting,
                sources: [].concat(sources)
            }
        );
        if (response) {
            await this.Serie.populate(
                { companyId: companyIdTo, sources: sources },
                {},
                {
                    companyId: companyIdTo,
                    accountingId: accounting._id
                }
            );
            await this.Dashboard.populateBySource({
                source: sources,
                companyId: companyIdTo
            });
            this.Available.modify(
                { companyId: { $eq: companyIdTo } },
                {
                    $unset: {
                        [`date.ORIGINAL.${sources}`]: 1
                    }
                }
            );

            this.Point.deleteMany({
                c: { $eq: companyIdTo },
                so: { $eq: this.Point.sourceOptions[sources] }
            });
        }

        return true;
    }
}
